module.exports = __webpack_public_path__ + "img/appAsset-brand--defontana.539e409d.svg";